// libs
import React, { useEffect } from "react";

// analytics
import { onPageLoad } from "shared/layouts/Homepage/analytics";

// components
import ScrollToTop from "shared/components/ScrollToTop";
import AdPlatformWidgetsDesktop from "shared/components/AdPlatformWidgets/Desktop";
import { GenericBrandDesc } from "shared/components/Footer";
import I18nShippingFAQ from "shared/components/I18nShippingFAQ";

// styles
import { scrollToTopCss } from "./styles";

// defs
import { ILandingPageProps } from "shared/components/AdPlatformWidgets/types";

interface IHomepageChild {
    homepageData: ILandingPageProps["landingPageData"];
    isI18n: boolean;
}

function Child({ homepageData, isI18n }: IHomepageChild) {
    useEffect(() => {
        onPageLoad(isI18n);
    }, [isI18n]);

    return (
        <>
            <AdPlatformWidgetsDesktop landingPageData={homepageData} />
            {isI18n ? <I18nShippingFAQ /> : <GenericBrandDesc />}
            <ScrollToTop cssProps={scrollToTopCss} />
        </>
    );
}

export default Child;
